<template>
    <div>
        <Modal
            v-model="isShow"
            class="live"
            class-name="vertical-center-modal"
            :title="$t('rg_createreal')"
            :mask-closable="false"
            footer-hide
            width="500"
            @on-ok="ok"
            @on-cancel="cancel">
            <div class="real-form">
                <Form :model="openModel" :rules="rules" class="realForm" ref="realForm" >
					<FormItem prop="accountType">
					    <effect-select :label='$t("accountType")' :options="accountType" v-model="openModel.accountType"></effect-select>
					</FormItem>
					<FormItem prop="currency">
					    <effect-select :label='$t("currencyType")' :options="currency" v-model="openModel.currency"></effect-select>
					</FormItem>
                    <FormItem prop="leverage">
						<effect-select :label='$t("leverage")' :options="leverage" v-model="openModel.leverage"></effect-select>
                    </FormItem>
                    <FormItem style="text-align:center;margin-bottom:0">
                        <Button type="primary"  @click="ok">{{$t('okApply')}}</Button>
                        <Button type="primary"  @click="cancel">{{$t('cancel')}}</Button>
                    </FormItem>
                </Form>
				<p>{{$t('liveTips1')}} <span class="number">{{length}}</span> {{$t('liveTips2')}},{{$t('liveTips3')}} <span class="number">{{userInfo.maxAccount}}</span> <span v-if="lang == 'zh'">{{$t('liveTips2')}}</span></p>
            </div>
        </Modal>
    </div>
</template>
<script>
	import {mapState} from 'vuex'
	import EffectSelect from '@/components/EffectSelect.vue';
	
    export default {
        components: {
            EffectSelect
        },
        props: {
            openDialog: {
                type: Boolean,
                default: false
            },
			length: {
				type:Number,
				default: 0
			}
        },
		computed: {
		    ...mapState(['userInfo','lang'])
		},
        data () {
            return {
                isShow: this.openDialog,
                openModel:{
					accountType: '',
					currency:'',
                    leverage:''
                },
				rules:{
					accountType:[{
						required: true,
						message: this.$t('accountTypePl')
					}],
					currency:[{
						required: true,
						message: this.$t('currencyTypePl')
					}],
					leverage:[{
						required: true,
						message: this.$t('leveragePl')
					}]
				},
				accountType: [],
				currency: [],
				leverage: [],
				click:true
            }
        },
        created(){
			this.$axios.get('/api/MyAccount/GetAccountType',{
				params:{
					isReal:1
				}
			})
			.then(async (res) => {
				// console.log(res)
				let dt = res.data
			    
			    if(dt.status == 1){
					let types = []
					
					dt.obj.accountType.map((a) => {
						types.push({
							label:a.typeName,
							value:a.typeCode
						})
					})
					this.accountType = types
					this.openModel.accountType = this.accountType[0].value
			    }
			})
        },
        watch: {
            openDialog (value) {
                this.isShow = value
            },
			'openModel.accountType'(val) {
				this.$axios.get('/api/MyAccount/GetRegistAccountSetting',{
					params:{
						accountType:val
					}
				})
				.then(async (res) => {
					let dt = res.data
				    
				    if(dt.status == 1){
						let currency = []
						let leverage = []
						
						dt.obj.currencys.map((c) => {
							currency.push({
								label:c,
								value:c
							})
						})
						dt.obj.leverages.map((l) => {
							leverage.push({
								label:'1:' + l,
								value:l
							})
						})
						this.currency = currency
						this.leverage = leverage
						this.openModel.currency = this.currency[0].value
						this.openModel.leverage = this.leverage[0].value
				    }
				})
			}
        },
        methods: {
            ok () {
				this.$refs['realForm'].validate((valid) => {
					if (valid) {
						if(this.click){
							this.click = false
						}else{
							return false
						}
						this.$axios.post('/api/MyAccount/AccountApply',this.openModel)
						.then(async (res) => {
							let dt = res.data
							this.click = true
						    if(dt.status == 1){
								this.$Message.success(dt.msg)
								this.cancel()
						    }else{
						        this.$Message.error(dt.msg)
						    }
						})
						.catch(() => {
							this.click = true
						})
					}
				})
            },
            cancel () {
                this.$emit('closeDialogReal',false)
				this.$refs['realForm'].resetFields()
            }
        }
    }
</script>
<style lang="less" >
	.real-form{
		p{
			margin-top: 20px;
		    color: #8b8b8c;
			span{
				&.number{
					color:red;
				}
			}
		}
		.ivu-form-item-error {
			.ivu-select-selection{
				border: 1px solid #ed4014!important;
			}
		}
	}
</style>